var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyaltyOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 262.977,
    height: 179.572,
    viewBox: "0 0 262.977 179.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_49_1",
    "data-name": "Component 49 \\u2013 1",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7002",
    "data-name": "Path 7002",
    d: "M516.12,484.055c-6.683-27.264-19.832-54.356-41.588-71.05-14.693-11.281-32.8-16.5-49.21-24.655-16.428-8.166-32.391-18.771-43.455-33.68-10.452-14.1-16.138-31.9-13.32-49.187H306.979c-.768,12.042-1.206,24.114-1.164,36.168.046,14.967,1.21,30.428,7.162,44.33,6.108,14.248,17.257,23.783,29.9,32.2,14.917,9.935,29.428,20.125,42.9,31.992,7.116,6.261,16.58,13.24,18.006,23.27a26.75,26.75,0,0,1-.806,10.616Z",
    transform: "translate(-305.812 -305.483)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7003",
    "data-name": "Path 7003",
    d: "M487.213,484.055c-5.249-32.155-12.175-66.265-33.764-91.688-11.806-13.887-27.9-20.919-42.082-31.786a47.7,47.7,0,0,1-17.036-23.635c-3.012-9.311-3.872-19.124-4.945-28.808-.1-.848-.164-1.738-.243-2.655H332.288c6.021,30.246,24.932,54.056,50.492,71.118C409.553,394.478,439.1,408,454.035,438.337a94.118,94.118,0,0,1,9.44,45.719Z",
    transform: "translate(-225.325 -305.483)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyOverlay);
export default __webpack_public_path__ + "static/media/loyalty-overlay.11ac6cfa6d533ed8d44982ae6b9cd50b.svg";
export { ForwardRef as ReactComponent };